import React from 'react'

export default ({
                    disabled,
                    className,
                    btnClass,
                    btnStyle,
                    selected,
                    items,
                    renderItem = e => e,
                    renderSelected,
                    onSelected = e => {},
                    getKey,
                    ...props}) => {

  let content;
  if(!disabled){
    content = (
      <ul className="dropdown-menu dropdown-multiple-select" aria-labelledby="dropdownMenu1">
        {
          items.map((x, i) => {
            const key = getKey ? getKey(x, i) : i;
            return <li
              key={key} className="clickable dropdown-item">
              <a onClick={() => onSelected(x)}>{renderItem(x)}</a>
            </li>
          })
        }
      </ul>
    );
  }

  return <div className={`dropdown ${className || ''}`} {...props}>
    <button
      className={`btn dropdown-toggle text-left pr-3 ${btnClass || ''} ${disabled ? 'disabled': ''}`}
      style={{...btnStyle}}
      data-toggle="dropdown">
      {
        renderSelected ? renderSelected(selected) : renderItem(selected)
      }
    </button>
    {content}
  </div>

}
